<template>
    <!-- 首页 -->
    <div id="home">
        <!-- 轮播组件 -->
		<Carousel :picList="picList" :autoplay="true"></Carousel>
        <div class="block part1">
            <div class="container">
				<h1 data-am-scrollspy="{animation: 'slide-top', repeat: false}">一款基于云的团餐食品安全监管平台。</h1>
				<p data-am-scrollspy="{animation: 'slide-right', delay: 500, repeat: false}">
					利用物联网、大数据、云计算等技术，通过对食材的品质管控及溯源追踪、食品加工过程中的 人、物、菜智能化管理，
					采用人工智能、大数据分析等手段，实现对学校、机关、企业等集中用餐环境的食品安全监管。从而构建一套严密高效、
					社会共治的食品安全治理体系，切实解决食品安全问题。
				</p>
				<img data-am-scrollspy="{animation: 'slide-bottom', delay: 800, repeat: false}" src="@/assets/images/home/pc_01.png" alt="">
			</div>
        </div>

		<!-- part2-核心产品 -->
        <div class="block part2">
            <div class="container">
				<h1 data-am-scrollspy="{animation: 'slide-top', repeat: false}">核心产品</h1>
				<ul class="show-list flex bCenter" id="my-scrollspy">
                    <li 
                        v-for="(item, index) in part2"
						:id="'my-scrollspy-part2-'+index"
                        :key="index"
                        :data-am-scrollspy="`{animation: 'scale-up', delay: ${500+(index+1)*200}, repeat: false}`"
						class="cursorPointer"
						>
                        <router-link :to="goPart2Path(item,index)">
                            <div class="img-rect flex middle center">
                                <img :src="item.cover" alt="">
                            </div>
                            <div class="content">
                                <h3>{{ item.title }}</h3>
                                <p>{{ item.disc }}</p>
                            </div>
                        </router-link>
					</li>
                </ul>
			</div>
        </div>

		<!-- part3-解决方案 -->
        <div class="block part3">
            <div class="container">
				<h1 data-am-scrollspy="{animation: 'slide-top', repeat: false}">解决方案</h1>
				<ul class="show-list flex bCenter">
                    <li 
                        v-for="(item, index) in part3" 
						:id="'my-scrollspy-part3-'+index"
                        :key="index"
                        :data-am-scrollspy="`{animation: 'scale-up', delay: ${500+(index+1)*200}, repeat: false}`"
						class="cursorPointer"
						>
                        <router-link :to="goPart3Path(item,index)">
                            <div class="img-rect flex middle center">
                                <img :src="item.cover" alt="">
                            </div>
                            <div class="content">
                                <h3>{{ item.title }}</h3>
                                <p>{{ item.disc }}</p>
                            </div>
                        </router-link>
					</li>
                </ul>
			</div>
        </div>

		<!-- part4-最新消息 -->
        <!-- <div class="block part4">
            <div class="container">
				<h1 data-am-scrollspy="{animation: 'slide-top', repeat: false}">最新消息</h1>
				<ul data-am-scrollspy="{animation: 'slide-left', delay: 500, repeat: false}" class="show-list flex bCenter">
                    <li v-for="(item, index) in part4" :key="index">
						<div class="img-rect flex middle center">
							<img :src="item.cover" alt="">
						</div>
						<div class="content">
							<h3>{{ item.title }}</h3>
							<p>{{ item.disc }}</p>
						</div>
					</li>
                </ul>
			</div>
        </div> -->
        <div class="block part4">
            <div class="container">
				<h1 data-am-scrollspy="{animation: 'slide-top', repeat: false}">最新消息</h1>
				<ul data-am-scrollspy="{animation: 'slide-left', delay: 500, repeat: false}" class="show-list flex bCenter">
                    <!-- <li v-for="(item, index) in indeusttyList" :key="'indeusttyList'+index" @click="goToDetails1(item.contentid,item,index)"> -->
                    <li v-for="(item, index) in indeusttyList" :key="'indeusttyList'+index">
                        <!-- <router-link :to="$utils.goDetailPagePath(item.contentid)" @click.native="goToDetails1(item.contentid,item,index)"> -->
                        <a :href="$constant.allHttpUrl.baseAddressUrl+$utils.goDetailPagePath(item.contentid)" @click.prevent="goToDetails1(item.contentid,item,index)">
                            <div class="img-rect flex middle center">
                                <img :src="fileUrl+item.coverImg" alt="">
                            </div>
                            <div class="content">
                                <h3>{{ item.title }}</h3>
                                <p>{{ item.summary }}</p>
                            </div>
                        </a>
					</li>
					<!-- <li v-for="(item, index) in newsList" :key="'newsList'+index" @click="goToDetails2(item.contentid,item,index)"> -->
					<li v-for="(item, index) in newsList" :key="'newsList'+index">
                        <!-- <router-link :to="$utils.goDetailPagePath(item.contentid)" @click.native="goToDetails2(item.contentid,item,index)"> -->
                        <a :href="$constant.allHttpUrl.baseAddressUrl+$utils.goDetailPagePath(item.contentid)" @click.prevent="goToDetails2(item.contentid,item,index)">
                            <div class="img-rect flex middle center">
                                <img :src="fileUrl+item.coverImg" alt="">
                            </div>
                            <div class="content">
                                <h3>{{ item.title }}</h3>
                                <p>{{ item.summary }}</p>
                            </div>
                        </a>
					</li>
                </ul>
			</div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import Carousel from 'components/Carousel/Carousel.vue';
import * as api_news from "service/api/methods/api_news.js"; //接口

import config from './config.js';
import metaInfoUtils from 'config/metaInfo.config.js';

export default {
	metaInfo: metaInfoUtils.currentMetaInfo('/'),
    components: {
        Carousel,
	},
	computed:{
		part4List(){
			return [...this.indeusttyList,...this.newsList];
		}
	},
    data() {
        return {
			...config,
            picList: [
                // {
                //     imgUrl: require('@/assets/images/home/pc_09.png'),
				// },
				{
                    imgUrl: require('@/assets/images/home/banner1.png'),
				},
				{
                    imgUrl: require('@/assets/images/home/banner2.png'),
				},
				{
                    imgUrl: require('@/assets/images/home/banner3.png'),
                }
			],
			//
			fileUrl:"",//
			indeusttyList:[],//行业咨询
			newsList:[],//新闻
			//动画
			Velocity:undefined,
			show:false,
        };
    },
    mounted(){
		// console.log("1111111:",process.env.BASE_URL);
		// document.title = 'AI智慧食堂-食品溯源-生鲜食材配送-校园食品安全-华略未来科技';

		require ("utils/js/amazeui.js");
		// require ("utils/css/amazeui.css");
		// this.Velocity=require ("velocity-animate");
		this.scrollspyListening();
		this.getContentList();
		this.getContentList2();

		// 监听滚动事件
    	// window.addEventListener("scroll", ()=>{
		// 	if(this.$utils.isElementNotInViewport(this.$refs.ttt)){
		// 		console.log("不在");
		// 	}else{
		// 		console.log("在");
		// 	}
		// });
	},
    methods: {
        goPart2Path(item,index){
            switch (index) {
				case 0://采购溯源系统
                    return '/softwareproducts/purchase';
				case 1://食堂管理系统
                    return '/softwareproducts/canteen';
				case 2://大数据监管系统
                    return '/softwareproducts/bigdata';
			}
        },

        goPart3Path(item,index){
            switch (index) {
				case 0://城投企业
                    return '/solution/uci-enterprise';
				case 1://教育局/市监局
                    return '/solution/e-ms-bureau';
				case 2://城投企业
                    return '/solution/uci-enterprise';
			}
        },

		goToDetails1(contentid,item,index){//行业资讯
			let p={contentid:contentid,newsType:0,typeid:item.typeid,isHome:item.isHome,status:item.status,index:index,page:1,rows:4,maxTotal:4};
            this.$storage.saveNewsDetailP(p);
            this.$router.push({path:this.$utils.goDetailPagePath(contentid)});
		},
		goToDetails2(contentid,item,index){//新闻
			let p={contentid:contentid,newsType:1,typeid:item.typeid,isHome:item.isHome,status:item.status,index:index,page:1,rows:4,maxTotal:4};
            this.$storage.saveNewsDetailP(p);
            this.$router.push({path:this.$utils.goDetailPagePath(contentid)});
		},
		getContentList(){//行业
			let p={
                typeid: 1,
                page: 1,
                rows:2,
                status: 1,
                isHome: 1,
            };
            api_news.getContentList(p).then((res)=>{
				this.fileUrl=res.baseUrl;
                this.indeusttyList=res.data||[];
            }).catch(error => {
            });
        },
		getContentList2(){//新闻
			let p={
                typeid: 4,
                page: 1,
                rows:1,
                status: 1,
                isHome: 1,
            };
            api_news.getContentList(p).then((res)=>{
				this.fileUrl=res.baseUrl;
                this.newsList=res.data||[];
            }).catch(error => {
            });
        },
		
		scrollspyListening(){
			$('[data-am-scrollspy]').scrollspy();

			//<!-- part2-核心产品 -->
			if($('#my-scrollspy-part2-1')){
				$('#my-scrollspy-part2-1').on('inview.scrollspy.amui', function() {
					// console.log('进入视口：',$('#my-scrollspy-part2-2').manualShow);
					if($('#my-scrollspy-part2-0')){
						$('#my-scrollspy-part2-0').manualShow();
					}
					if($('#my-scrollspy-part2-2')){
						// console.log("manualShow")
						$('#my-scrollspy-part2-2').manualShow();
					}
				}).on('outview.scrollspy.amui', function() {
					// console.log('离开视口');
					if($('#my-scrollspy-part2-2')){
						$('#my-scrollspy-part2-2').manualHide();
					}
				});
			}

			//<!-- part3-解决方案 -->
			if($('#my-scrollspy-part3-1')){
				$('#my-scrollspy-part3-1').on('inview.scrollspy.amui', function() {
					// console.log('进入视口');
					if($('#my-scrollspy-part3-0')){
						$('#my-scrollspy-part3-0').manualShow();
					}
					if($('#my-scrollspy-part3-2')){
						$('#my-scrollspy-part3-2').manualShow();
					}
				}).on('outview.scrollspy.amui', function() {
					// console.log('离开视口');
					if($('#my-scrollspy-part3-2')){
						$('#my-scrollspy-part3-2').manualHide();
					}
				});
			}
		}
	},
};
</script>

<style lang="less" scoped>
@import '~utils/css/amazeui.css';
@import '~utils/css/general.less';
@import '~utils/css/elementOften.less';
@import './index.less';
</style>
